import BaseEvent from './base_event';
import BreachEvent from './breach';
import * as effects from '../effects'
import * as ItemsFactory from '../../objects/items/items_factory';
import Fire from '../../objects/items/fire';
import { Rarity } from '../../objects/items/base_item'

export default class PiratesEvent extends BaseEvent {

    static canOccur(gameState) {
        return !gameState.eventsResults.pirates;
    }

    enter(gameState) {
        gameState.eventsResults.pirates = true;

        let room = gameState.getRandomRoomWithoutHero();

        this.ui.showDialog({
            message:
                `It’s a Space Operating Pirates Alarm! Must have locked onto your torrent tracker! You try to run away, but they quickly corner you into a space-time fold. Your comms channel spews a rather direct inquire: "We’re here to plunder ya booty! Prepare to share your files!"`,
            options: [{
                text: `(Arms the* ship cannon* with* Jenkins*) Plunder my booty? I’ll plunder YOURS! GO ASSAULT DROID!`,
                condition: gameState.has('jenkins') && gameState.has('gun_terminal'),
                callback: () => {
                    let dice_roll = game.rnd.frac();

                    if (dice_roll < 0.85) {
                        gameState.history.push({ id: 'prt', msg: `assaulted a pirate ship with robot janitor` });
                        let item = ItemsFactory.produceByRarity(room, Rarity.RARE)[0];
                        gameState.items.add(item);

                        this.ui.showDialog({
                            message: `Using kitchenware from your previous cooking experiments as a highly effective composite armor, your trusty droid crashes into a pirate ship and makes the short work of its crew. Then the pirate ship explodes, and your heart skips a beat, only to see one escape pod coming back to you. Phew.. for a second there you thought your creativity won’t pay off with an item.`,
                            status: "+" + item.constructor.label
                        }, this.end);
                    } else {
                        gameState.history.push({ id: 'prt', msg: `got dumped by his robot janitor` });
                        this.ui.showDialog({
                            message: `Using kitchenware from your previous cooking experiments as a highly effective composite armor, your trusty droid crashes into a pirate ship and makes the short work of its crew. Then you hear his laughter over radio: "Goodbye, meatbag", and the ship is gone. Aw, shucks!`,
                            status: "Jenkins lost"
                        }, () => {
                            gameState.remove('jenkins');
                            this.end();
                        });
                    }
                }
            }, {
                text: `Fire the* ship cannon*! They will never get my genuine ware!`,
                condition: gameState.has('gun_terminal'),
                callback: () => {
                    let dice_roll = game.rnd.frac();

                    if (dice_roll < 0.1) {
                        let gunTerminal = gameState.findFirstAvailable('gun_terminal');

                        this.ui.showDialog({
                            message: `You punch the fire button so hard your cannon goes into the overdrive mode and obliterates pirates in no time. It also explodes in the process.`,
                            status: "Gun Terminal lost"
                        }, () => {
                            gameState.history.push({ id: 'prt', msg: `securely erased a pirate ship from the space-time` });
                            effects.createSparkRandom(gunTerminal.x, gunTerminal.y);
                            effects.createExplosion(gunTerminal.x, gunTerminal.y);
                            gameState.items.removeItem(gunTerminal);
                            this.end();
                        });
                    } else if (dice_roll < 0.3) {
                        let item = ItemsFactory.produceMany(room, Fire)[0];
                        gameState.items.add(item);
                        gameState.history.push({ id: 'prt', msg: `defeated the dreaded space pirates in a honest fight` });
                        this.ui.showDialog({
                            message: `After a short and intense firefight you manage to hit the reactor, and pirate ship explodes in a firework of stolen bits. You ever manage to dodge all of their shots, right? Is… Is something burning?`,
                            status: "Fire alert!"
                        }, this.end);
                    } else {
                        gameState.history.push({ id: 'prt', msg: `defeated the dreaded space pirates without scratching the ship paint` });
                        this.ui.showDialog({
                            message: `After a short and intense firefight you manage to hit the reactor, and pirate ship explodes in a firework of stolen bits. What a gorgeous sight!`
                        }, this.end);
                    }
                }
            }, {
                text: `Drive me closer! I want to hit them with my ship!`,
                condition: gameState.energy > 0,
                callback: () => {
                    let dice_roll = game.rnd.frac();

                    if (dice_roll < 0.4) {
                        gameState.setEnergy(0);
                        gameState.history.push({ id: 'prt', msg: `made space pirates laugh so hard they decide to leave` });
                        this.ui.showDialog({
                            message: `You fire up your engines, yell at the comms channel and go straight at the enemy ship, because even death is better than being robbed by an s-pirates. Unfortunately, their ship is faster, and you spend all your energy running in circles. After the end, pirates thank you for a great entertainment and fly away, laughing.`,
                            status: "Energy drained"
                        }, this.end);
                    } else if (dice_roll < 0.8) {
                        gameState.history.push({ id: 'prt', msg: `pull off a space ramming maneuver with a huge success` });
                        this.ui.showDialog({
                            message: `You fire up your engines, yell at the comms channel and go straight at the enemy ship, scoring a good hit right in the side. Clearly refusing to deal with this horse manure, pirates quickly turn around and fly away, leaving you a winner of this battle. Now what’s with that hissing sound?`,
                            status: "Hull breach!"
                        }, () => {
                            this.schedule(BreachEvent, 0);
                        });
                    } else {
                        gameState.history.push({ id: 'prt', msg: `became a formidable space rammer` });
                        this.ui.showDialog({
                            message: `You fire up your engines, yell at the comms channel and go straight at the enemy ship, because even death is better than being robbed by an s-pirates. Shocked with your stupidity, they fail to maneuver away, and you hit the solar sail. With their ship immobilized, you are free to go.`
                        }, this.end);
                    }
                }
            }, {
                text: `I give up! Take my stuff.`,
                callback: () => {
                    let item = null;
                    gameState.items.forEachStanding( o => { item = o; }); // TODO: more expensive item?

                    let itemLabel = item ? item.constructor.label : "nothing"; // TODO: change text if you have no items 
                    // meh, nothing is fine
                    gameState.history.push({ id: 'prt', msg: `surrendered to a pirate scum and lost his softwares` });
                    this.ui.showDialog({
                        message: `Pirates skim through your ship, taking genuine Portholes install cd and some old Photoshoot distributions. One of them looks at your* ` + itemLabel + `* apprehensively and takes it on the ship, which then flies away for another victim. You promise yourself not to use torrent trackers anymore, and get back to watching online movie streams.`,
                        status: "- " + itemLabel
                    }, () => {
                        if (item) {
                            gameState.items.removeItem(item);
                        }
                        this.end();
                    });
                }
            }]
        });
    }


}



// WEBPACK FOOTER //
// ./src/states/events/pirates.js